// Seeded LCG — port of the HTML prototype `rng()` (lines 681–689).
// Deterministic across runs for the same seed; cheap enough to call in
// inner loops. The closure form lets renderers grab a stream once and pull
// many values without re-seeding.

export type Rng = () => number;

export function makeRng(seed: number): Rng {
  let s = seed | 0;
  return function next(): number {
    s = (s + 0x6d2b79f5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4_294_967_296;
  };
}

// Single-shot variant — equivalent to `makeRng(seed)()` but skips the
// closure allocation, intended for hot loops that pull a single value.
export function rngOnce(seed: number): number {
  let s = seed | 0;
  s = (s + 0x6d2b79f5) | 0;
  let t = Math.imul(s ^ (s >>> 15), 1 | s);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return ((t ^ (t >>> 14)) >>> 0) / 4_294_967_296;
}
